import { Component, Input } from '@angular/core';
import { Supplier } from '../product.types';

@Component({
  selector: 'b4a-product-supplier-list',
  templateUrl: './supplier-list.component.html'
})
export class SupplierListComponent {

  @Input()
  suppliers: Supplier[];

  @Input()
  clickedNew;
}



// WEBPACK FOOTER //
// ./src/app/product/supplier-list/supplier-list.component.ts